import React from "react";
import PropTypes from "prop-types";
import { isFunction, gatherClasses } from "../../lib/utils";
import Tooltip from "../tooltip/tooltip";

const MenuItem = ({ item, children }) => {
  const { tooltip = {}, ...rest } = item;
  const { text } = tooltip;
  const tooltipContent = isFunction(text) ? text(rest) : text;
  const classes = gatherClasses(
    null,
    "oui-tagsel-item-inner",
    rest.isDisabled ? "oui-tagsel-item-inner--disabled" : null
  );

  return (
    <div className={classes}>
      {tooltipContent ? (
        <Tooltip {...tooltip} text={tooltipContent}>
          <span className="oui-tagsel-item-with-tooltip">{children}</span>
        </Tooltip>
      ) : (
        children
      )}
    </div>
  );
};

MenuItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isDisabled: PropTypes.bool,
    tooltip: PropTypes.shape({
      placement: PropTypes.string,
      maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      overflowOnly: PropTypes.bool,
      showTooltip: PropTypes.bool
    })
  }),
  children: PropTypes.node
};

export default MenuItem;
